<template>
  <div>
    <div>
      <div v-if="title">
        <span class="fob-compact-item-title">{{title}}</span>
      </div>
      <div v-if="data.projektLeiter">
        {{ fullName(data.projektLeiter) }}
      </div>
      <div v-if="data.projektBeginn !== null">
        <i><translate>Forschungsprojekt.compact.Laufzeit</translate></i>: {{ duration(data.projektBeginn, data.projektEnde) }}
      </div>
      <div v-if="funding">
        <span class="fob-compact-item-key"><translate>Forschungsprojekt.compact.Mittelgeber</translate>:</span>
        <span>{{ funding }}</span>
      </div>
      <div v-if="organisationalUnits">
        <span class="fob-compact-item-key"><translate>Forschungsprojekt.compact.organisationseinheiten</translate>:</span>
        <span>{{ organisationalUnits }}</span>
      </div>
    </div>
  </div>
</template>

<script>

import CompactViewHelper from '@/components/mixins/CompactViewHelper'
import DateTimeHelper from '@/components/mixins/DateTimeHelper'

export default {
  name: 'fob--compact',
  props: ['schema', 'data'],
  mixins: [CompactViewHelper, DateTimeHelper],
  computed: {
    title () {
      if (this.currentLocale === 'de') {
        return (this.data.titelDE != null && this.data.titelDE.trim() !== '')
        ? this.data.titelDE
        : this.data.titelEN || ''
      } else {
        return (this.data.titelEN != null && this.data.titelEN.trim() !== '')
        ? this.data.titelEN
        : this.data.titelDE || ''
      }
    },
    funding () {
      let fundingAgency = []
      this.data.foerderung.forEach((funding) => {
        if (funding.mittelgeber && funding.mittelgeber.name && !fundingAgency.includes(funding.mittelgeber.name)) {
          fundingAgency.push(funding.mittelgeber.name)
        }
      })
      return fundingAgency.join('; ')
    },
    organisationalUnits () {
      // fetch all ous
      let ous = []
      if (this.data.organisationseinheit) {
        ous.push(this.data.organisationseinheit.name)
      }
      if (Array.isArray(this.data.weitereOrganisationseinheiten) && this.data.weitereOrganisationseinheiten.length > 0) {
        ous = ous.concat(this.data.weitereOrganisationseinheiten.map(ou => ou.name))
      }
      // build ous string
      return ous.join('; ')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/compact/Forschungsprojekt.vue